export const X_LINK = "https://x.com/KuromiERC"
export const TG_LINK = "https://t.me/KuromiOnEth"